import { FormInput } from '@/components/form/form-input';
import { FormSelect } from '@/components/form/form-select';
import { FormBackHeader } from '@/components/form/form-back-header';
import { Button } from '@/components/ui/button';
import { FormProvider } from 'react-hook-form';
import { useGoogleCalendarShare } from '../../hooks/google-calendar.hooks';

type SubCalendarOption = { value: string; label: string };

const GoogleCalendarForm = () => {
  const {
    form,
    onSubmit,
    isLoading,
    isEdit,
    subCalendarOptions,
    subCalendarsLoading,
  } = useGoogleCalendarShare();

  return (
    <div className="space-y-6">
      <FormProvider {...form}>
        <form className="space-y-6" onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6 px-6 py-2">
            <div className="flex items-center justify-between rounded-2xl">
              <FormBackHeader title="Go Back" />

              <Button
                variant="primary"
                size="sm"
                type="submit"
                disabled={isLoading}
                loading={isLoading}
              >
                {isEdit ? 'Save Changes' : 'Share Calendar'}
              </Button>
            </div>
          </div>

          <div className="space-y-4 rounded-2xl bg-neutral-100 p-6">
            <div className="grid grid-cols-2 gap-4">
              <FormInput
                name="email"
                label="Email"
                placeholder="e.g. user@example.com"
                type="email"
                required
                disabled={isEdit}
              />
              <FormSelect<SubCalendarOption, true>
                name="subCalendars"
                label="Sub Calendars"
                placeholder="Select sub calendars"
                options={subCalendarOptions}
                optionKey="value"
                getOptionLabel={(opt: SubCalendarOption) => opt.label}
                getOptionValue={(opt: SubCalendarOption) => opt.value}
                isMulti
                isLoading={subCalendarsLoading}
                required={!isEdit}
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default GoogleCalendarForm;
